export default "__VITE_ASSET__DJvBIZ3Q__"